import { HttpMethod } from '@vision/ui/enums';
import { TicketManagerMemberRole } from '@vision/ui/interfaces';
import { TicketManagerApiRequest } from '../ticket-manager.api';
import { TicketManagerPoolDeleteArgs, TicketManagerTicketsExportArgs } from './pools.api.types';

const TICKET_MANAGER_INNER_LOOP_ENDPOINT = '/v2/inner_loop';

export const buildGetProjectPoolsRequest = ({ projectId }: { projectId: string }): TicketManagerApiRequest => ({
  method: HttpMethod.GET,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/pools`,
});

export const buildCreatePoolRequest = ({
  name,
  nodeId,
  projectId,
}: {
  name: string;
  nodeId: string;
  projectId: string;
}): TicketManagerApiRequest => ({
  data: {
    name,
    node_id: nodeId,
  },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/pools`,
});

export const buildUpdatePoolRequest = ({
  name,
  nodeId,
  poolId,
  projectId,
}: {
  name: string;
  nodeId: string;
  poolId: string;
  projectId: string;
}): TicketManagerApiRequest => ({
  data: {
    name,
    node_id: nodeId,
  },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/pools/${poolId}/update`,
});

export const buildGetPoolMembersRequest = ({
  poolId,
  projectId,
}: {
  poolId: string;
  projectId: string;
}): TicketManagerApiRequest => ({
  method: HttpMethod.GET,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/pools/${poolId}/members`,
});

export const buildAddPoolMemberRequest = ({
  poolId,
  projectId,
  role,
  userId,
}: {
  poolId: string;
  projectId: string;
  role: TicketManagerMemberRole;
  userId: string;
}): TicketManagerApiRequest => ({
  data: {
    role,
    user_id: userId,
  },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/pools/${poolId}/add_member`,
});

export const buildRemovePoolMemberRequest = ({
  poolId,
  projectId,
  userId,
}: {
  poolId: string;
  projectId: string;
  userId: string;
}): TicketManagerApiRequest => ({
  data: {
    user_id: userId,
  },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/pools/${poolId}/remove_member`,
});

export const buildExportPoolTicketsRequest = ({
  from_date,
  poolId,
  priorities,
  projectId,
  status_ids,
  to_date,
}: TicketManagerTicketsExportArgs): TicketManagerApiRequest => ({
  data: {
    from_date,
    priorities,
    status_ids,
    to_date,
  },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/pools/${poolId}/export_tickets`,
});

export const buildDeletePoolRequest = ({
  projectId,
  poolId,
}: TicketManagerPoolDeleteArgs): TicketManagerApiRequest => ({
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/pools/${poolId}/delete`,
});
